import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	updateIdentificationInfo,
	type UpdateIdentificationInfoRequest,
	type UpdateIdentificationInfoResponse,
} from '../../http';

export function useUpdateIdentificationInfo(
	options?: UseMutationOptions<
		UpdateIdentificationInfoResponse,
		AxiosError,
		UpdateIdentificationInfoRequest
	>,
): UseMutationResult<UpdateIdentificationInfoResponse, AxiosError, UpdateIdentificationInfoRequest> {
	const queryClient = useQueryClient();

	return useMutation<UpdateIdentificationInfoResponse, AxiosError, UpdateIdentificationInfoRequest>(
		(request) => updateIdentificationInfo(request).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				queryClient.invalidateQueries({queryKey: ['profile']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
